import { AuthClient } from "./magicClients/AuthClient";
import { ApprovalActivitiesClient } from "./magicClients/ApprovalActivitiesClient";

export const AuthAccessor = new AuthClient();
export const ApprovalActivityAccessor = new ApprovalActivitiesClient();
